<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Invoice</legend>
            <!--Grid row-->

            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="From Date:" label-for="input-1">
                        <datepicker size="sm" v-model="fromDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="To Date:" label-for="input-1">
                        <datepicker v-model="toDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                    <br />
                          <b-button type="button" @click="getReport" pill  variant="outline-dark">
                            Retrieve Invoice
                        </b-button>
                </b-col>
                <b-col sm="12" md="2" >
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <strong>Umbai Africa (Pvt)</strong>
                    <p>email : support@umbai.co.za</p>
                </b-col>
                <b-col sm="12" md="6">
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                <strong>Invoice No</strong>
                <p>{{invoiceHeading}}</p>
                <strong>Date</strong>
                <p>{{toDate}}</p>
                </b-col>
                <b-col sm="12" md="2" >
                </b-col>
            </b-row>

                    

            </b-row>
            <div class="row pt-3">
                <div class="table-responsive">
                    <b-table striped hover bordered :items="items" :fields="fields">
                    </b-table>
                    <br />
                    <p>
                       <strong>Total ZAR :</strong> {{totalAmount}}
                    </p>
                </div>
            </div>
            <!--spinner-->
            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
            <!--spinner-->
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>